import { render } from "./App.vue?vue&type=template&id=57dea3a2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./css/nicepage.css?vue&type=style&index=0&lang=css"
import "./App.vue?vue&type=style&index=1&id=57dea3a2&lang=css"

import exportComponent from "/codebuild/output/src991838332/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/splats-mypage-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__